// Meta Pixel utility — injects the Facebook Pixel base code and exposes tracking helpers.
// All logic is wrapped in try/catch so a pixel/network/CSP failure can NEVER crash the app.

const PIXEL_ID = '1016054377793758'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

let initialized = false

/**
 * Injects the Meta Pixel base script, initializes the pixel and fires PageView.
 * Safe to call multiple times — it only initializes once. Fully guarded so any
 * failure (blocked script, CSP, missing DOM node) is silently ignored.
 */
export function initMetaPixel(): void {
  if (typeof window === 'undefined' || initialized) return
  initialized = true

  try {
    /* eslint-disable */
    ;(function (f: any, b: Document, e: string, v: string) {
      if (f.fbq) return
      const n: any = (f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments)
      })
      if (!f._fbq) f._fbq = n
      n.push = n
      n.loaded = true
      n.version = '2.0'
      n.queue = []
      const t = b.createElement(e) as HTMLScriptElement
      t.async = true
      t.src = v
      const s = b.getElementsByTagName(e)[0]
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s)
      } else {
        // Fallback: no existing <script> tag to insert before (e.g. sandboxed preview)
        ;(b.head || b.body || b.documentElement).appendChild(t)
      }
    })(
      window,
      document,
      'script',
      'https://connect.facebook.net/en_US/fbevents.js',
    )
    /* eslint-enable */

    if (typeof window.fbq === 'function') {
      window.fbq('init', PIXEL_ID)
      window.fbq('track', 'PageView')
    }
  } catch (err) {
    // Never let analytics break the page.
    console.warn('Meta Pixel init skipped:', err)
  }
}

/**
 * Fires the AddToCart standard event. Fully guarded.
 */
export function trackAddToCart(params?: Record<string, unknown>): void {
  try {
    if (typeof window === 'undefined' || typeof window.fbq !== 'function')
      return
    window.fbq('track', 'AddToCart', params)
  } catch (err) {
    console.warn('Meta Pixel AddToCart skipped:', err)
  }
}
